import React from 'react';
import { IconButton, cn } from '../ui';

export interface FontSizeControlProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

export const FontSizeControl: React.FC<FontSizeControlProps> = ({
  value,
  onChange,
  min = 14,
  max = 36,
  step = 2,
  className,
}) => {
  return (
    <div className={cn('inline-flex items-center gap-1 rounded-full bg-bg-3 border border-light px-1 py-0.5', className)}>
      <IconButton
        ariaLabel="Decrease lyrics font"
        size="sm"
        variant="ghost"
        onClick={() => onChange(Math.max(min, value - step))}
        icon={<span className="text-body font-semibold">A−</span>}
      />
      <span className="px-1 font-mono text-small text-text-secondary tabular-nums w-8 text-center">{value}</span>
      <IconButton
        ariaLabel="Increase lyrics font"
        size="sm"
        variant="ghost"
        onClick={() => onChange(Math.min(max, value + step))}
        icon={<span className="text-body font-semibold">A+</span>}
      />
    </div>
  );
};
